import React, { useState } from "react";
import "./App.css";
import party from "./party.svg";

function App() {
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [color, setColor] = useState("black");
  const [output, setOutput] = useState("");

  const checkPalindrome = (dateArray) => {
    if (name === "" || date === "") {
      setOutput("Please Enter Your Name and a Date");
      return;
    }
    let ans;
    for (let arraylength = 0; arraylength < 6; arraylength++) {
      let date = dateArray[arraylength];
      ans = true;
      // console.log(date);
      for (let i = 0; i < 4; i++) {
        if (date[i] !== date[date.length - 1 - i]) {
          ans = false;
          break;
        }
      }
      if (ans) {
        setOutput(
          `Your birthdate is Palindrome! (if arranged in order ${date})`
        );
        setColor("green");
        break;
      }
    }
    if (!ans) {
      setOutput("Your birthdate is NOT Palindrome!");
      setColor("red");
    }
  };

  let dateArray = date.split("-");

  const date1 = dateArray[0] + dateArray[1] + dateArray[2]; //ymd
  const date2 = dateArray[0] + dateArray[2] + dateArray[1]; //ydm
  const date3 = dateArray[1] + dateArray[0] + dateArray[2]; //myd
  const date4 = dateArray[1] + dateArray[2] + dateArray[0]; //mdy
  const date5 = dateArray[2] + dateArray[1] + dateArray[0]; //dmy
  const date6 = dateArray[2] + dateArray[0] + dateArray[1]; //dym
  dateArray = [date1, date2, date3, date4, date5, date6];

  return (
    <div className="App">
      <img src={party} alt="logo" />
      <h1>Hello {name}</h1>
      <input
        placeholder="Enter Name ..."
        type="text"
        onChange={(e) => setName(e.target.value)}
      />
      <input type="date" onChange={(e) => setDate(e.target.value)}></input>

      <button onClick={() => checkPalindrome(dateArray)}>
        checkPalindrome
      </button>
      <h2 style={{ color: color }}>{output}</h2>
    </div>
  );
}

export default App;
